/**
 *  ==========================
 *  BLOCK: Icon Block
 *  ==========================
 */

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n'
import {
    disabledBlocks, i18n, srcUrl
} from 'cartzillagb'
import { applyFilters } from '@wordpress/hooks'
import DefaultImage  from  './img/img1.png'

/**
 * Internal dependencies
 */
import edit from './edit'
import save from './save'
import { HeaderIcon } from '~cartzillagb/icons'
import { range } from '~cartzillagb/util'

export const schema = {
    disableTitle: {
        type: 'boolean',
        default: false,
    },
    limit: {
        type: 'number',
        default: 3,
    },
    'smColumns': {
        type: 'number',
        default: 3,
    },
    enablePosition: {
        type: 'boolean',
        default: true,
    },
}

const limit = applyFilters( 'cartzillagb.category-block.icon.edit.inspector.max.bannerlimit', 6 )

{ range( 1, limit + 1 ).map( i => {
    schema[ `link${ i }` ] = {
        type: 'string',
    }
    schema[ `mediaURL${ i }` ] = {
        type: 'string',
        default: `${ srcUrl }/${ DefaultImage }`
    }
    schema[ `title${ i }` ] = {
        type: 'string',
    }
        return ""
} ) }

export const name = 'czgb/category-block'

export const settings = {
    title: __( 'Image Grid', i18n ),
    description: __( 'Display images in a grid with links.', i18n ),
    icon: HeaderIcon,
    category: 'cartzillagb',
    example: {},
    keywords: [
        __( 'Category Block', i18n ),
        __( 'CartzillaGB', i18n ),
    ],
    attributes: schema,
    supports: {
        inserter: ! disabledBlocks.includes( name ), // Hide if disabled.
    },

    edit,
    save,

    // CartzillaGB modules.
    modules: {
        'advanced-responsive': true,
    },
}
